import * as React from "react";

interface RefProps {
    color?: string;
    size?: number;
    fill?: string
}

export const SlideTransitionIcon = React.forwardRef<SVGSVGElement, RefProps>(({ color = 'currentColor', size = 24, fill = 'black', ...rest }, ref) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather" ref={ref} {...rest}>
            <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" />
            <path d="M7 12H17" />
            <path d="M12 7L17 12L12 17" />
        </svg>
    );
});

export const SlideFadeIcon = React.forwardRef<SVGSVGElement, RefProps>(({ color = 'currentColor', size = 24, fill = 'black', ...rest }, ref) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather" ref={ref} {...rest}>
            <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" stroke-dasharray="2 5" />
        </svg>
    );
});


export const SlideFlowIcon = React.forwardRef<SVGSVGElement, RefProps>(({ color = 'currentColor', size = 24, fill = 'black', ...rest }, ref) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={48} height={size} viewBox="0 0 48 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather" ref={ref} {...rest}>
            <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"/>
<path d="M43 3H29C27.8954 3 27 3.89543 27 5V19C27 20.1046 27.8954 21 29 21H43C44.1046 21 45 20.1046 45 19V5C45 3.89543 44.1046 3 43 3Z"/>
<path d="M8 12L39 12"/>
<path d="M34 7L39 12L34 17"/>
        </svg>
    );
});

{/* <path d="M21.1111 8H14.8889C14.398 8 14 8.39797 14 8.88889V15.1111C14 15.602 14.398 16 14.8889 16H21.1111C21.602 16 22 15.602 22 15.1111V8.88889C22 8.39797 21.602 8 21.1111 8Z" />
<path d="M9.11111 8H2.88889C2.39797 8 2 8.39797 2 8.88889V15.1111C2 15.602 2.39797 16 2.88889 16H9.11111C9.60203 16 10 15.602 10 15.1111V8.88889C10 8.39797 9.60203 8 9.11111 8Z" />
<path d="M4 12H19" />
<path d="M16 10L19 12L16 14" /> */}